'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _OnScreen = require('lib/OnScreen');

var _OnScreen2 = _interopRequireDefault(_OnScreen);

var _Hero = require('components/Hero/Hero');

var _Hero2 = _interopRequireDefault(_Hero);

var _Clients = require('components/Clients/Clients');

var _Clients2 = _interopRequireDefault(_Clients);

var _Feature = require('components/Feature/Feature');

var _Feature2 = _interopRequireDefault(_Feature);

var _Media = require('components/Media/Media');

var _Media2 = _interopRequireDefault(_Media);

var _technical = require('./technical.css');

var _technical2 = _interopRequireDefault(_technical);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Technical = function (_Component) {
  _inherits(Technical, _Component);

  function Technical() {
    _classCallCheck(this, Technical);

    var _this = _possibleConstructorReturn(this, (Technical.__proto__ || Object.getPrototypeOf(Technical)).call(this));

    _this.state = {
      finishLoading: false,
      cmsData: {},
      hero: {},
      features: {},
      services: {},
      clients: {},
      servicesInView: false
    };
    return _this;
  }

  _createClass(Technical, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var fetchTechnical = this.props.fetchTechnical;


      document.title = 'Technical | Soundscape Agency';
      fetchTechnical();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.servicesShow = _OnScreen2.default.in(this.refs.services, this.showServices.bind(this), false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      if (this.props.features !== newProps.features) {
        this.setState({
          hero: newProps.hero,
          features: newProps.features,
          services: newProps.services,
          clients: newProps.clients,
          finishLoading: true
        });
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      _OnScreen2.default.unsubscribe(this.servicesShow);
    }
  }, {
    key: 'showServices',
    value: function showServices() {
      this.setState({
        servicesInView: true
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          finishLoading = _state.finishLoading,
          hero = _state.hero,
          features = _state.features,
          services = _state.services,
          clients = _state.clients;


      return _react2.default.createElement(
        'div',
        { className: _technical2.default.creative },
        _react2.default.createElement(_Hero2.default, {
          title: 'technical.',
          strap: hero.strap,
          bg: hero.bg
        }),
        _react2.default.createElement(
          'section',
          { className: _technical2.default.features },
          _react2.default.createElement(
            'div',
            { className: _technical2.default.featuresInner },
            finishLoading && features.items && features.items.map(function (item, index) {
              var icon = item.icon;
              var title = item.title;
              var copy = item.copy;

              return _react2.default.createElement(_Feature2.default, {
                key: 'featureItem_' + index,
                className: _technical2.default.feature,
                icon: icon,
                title: title,
                copy: copy
              });
            })
          )
        ),
        _react2.default.createElement(
          'section',
          { className: _technical2.default.services, ref: 'services' },
          _react2.default.createElement(
            'div',
            { className: _technical2.default.servicesInner },
            _react2.default.createElement(
              'div',
              { className: _technical2.default.servicesHero, style: { opacity: this.state.servicesInView ? 1 : 0 } },
              _react2.default.createElement(
                'h3',
                { className: _technical2.default.title },
                services.title
              ),
              _react2.default.createElement('p', {
                className: _technical2.default.strap,
                dangerouslySetInnerHTML: { __html: services.strap }
              })
            ),
            finishLoading && services.items && _react2.default.createElement(
              _Media2.default,
              {
                ltr: true,
                num: '01',
                title: services.items[0].title,
                icon: 'solutions'
              },
              services.items[0].copy
            ),
            finishLoading && services.items && _react2.default.createElement(
              _Media2.default,
              {
                ltr: false,
                num: '02',
                title: services.items[1].title,
                icon: 'light'
              },
              services.items[1].copy
            ),
            finishLoading && services.items && _react2.default.createElement(
              _Media2.default,
              {
                ltr: true,
                num: '03',
                title: services.items[2].title,
                icon: 'network'
              },
              services.items[2].copy
            ),
            finishLoading && services.items && _react2.default.createElement(
              _Media2.default,
              {
                ltr: false,
                num: '04',
                title: services.items[3].title,
                icon: 'control'
              },
              services.items[3].copy
            )
          )
        ),
        finishLoading && clients.logos && _react2.default.createElement(_Clients2.default, {
          title: clients.title,
          strap: clients.strap,
          clients: clients.logos
        })
      );
    }
  }]);

  return Technical;
}(_react.Component);

exports.default = Technical;


Technical.contextTypes = {
  router: _react2.default.PropTypes.object.isRequired
};


//////////////////
// WEBPACK FOOTER
// ./src/components/Technical/Technical.js
// module id = 339
// module chunks = 1